// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"98a2447d","177":"aaa269ae","976":"2955f216"}[chunkId] + ".chunk.css";
};